import React from 'react';
import {
  getRouteApi,
  useLoaderData,
} from '@tanstack/react-router';

import Pagination from '../../Pagination';
import PaginationHeader from '../../PaginationHeader';
import DashboardAdminShare from './Share';

import type { Share } from '../../../types/share';

const DashboardAdminShares: React.FC = () => {
  const routeApi = getRouteApi('/dashboard/admin/users/$userId');
  const { user } = routeApi.useLoaderData()

  const { shares: sharesData } = useLoaderData({ strict: false });
  const shares = sharesData?.data || [];
  const totalShares = sharesData?.meta.total;
  const perPage = sharesData?.meta.per_page;

  return (
    <>
      <div className="dashboard-header page-header">
        <h2 className="page-title">All <em>shares</em></h2>
        <p>All shares by {user.name} ({user.email})</p>
      </div>
      <div className="dashboard-admin dashboard-admin-users wa-stack wa-gap-0 inner">
        <div className="wa-grid">
          <div className="total-items">
            <PaginationHeader text="share" total={totalShares} perPage={perPage} />
          </div>
        </div>
        <div className="dashboard-admin-users-list wa-stack">
          <table>
            <thead>
              <tr>
                <th>Sent at</th>
                <th>Email</th>
                <th>Name</th>
                <th>Memory / SPRK</th>
                <th>Timeline</th>
                <th>Views</th>
                <th className="actions">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {shares.map((share: Share) => (
                <DashboardAdminShare
                  key={share.id}
                  share={share}
                />
              ))}
            </tbody>
          </table>
          <Pagination total={totalShares} perPage={perPage} />
        </div>
      </div>
    </>
  );
}

export default DashboardAdminShares;
